(function () {
  var prepaidCart = null;
  var bannerTimer = null;
  function money(paise) {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: paise % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(paise / 100);
  }
  function updatePrepaid(cart) {
    prepaidCart = cart;
    var frame = document.querySelector('iframe.razorpay-sidecart-frame');
    if (!frame || !frame.contentWindow || !cart) return;
    var origin;
    try { origin = new URL(frame.src).origin; } catch (error) { return; }
    if (origin !== 'https://api.razorpay.com') return;
    var total = Number(cart.total_price);
    var eligible = cart.item_count > 0 && cart.currency === 'INR' && Number.isFinite(total) && total > 0;
    var estimate = Math.round(total * 90 / 100);
    var message = eligible ? 'Prepaid estimate ' + money(estimate) + ' · Extra 10% off. Partial COD: advance online, balance on delivery. Final amounts and eligibility at checkout.' : 'Partial COD: advance online, balance on delivery. Extra 10% off eligible prepaid orders at checkout.';
    frame.contentWindow.postMessage({ source: 'sidecart', eventType: 'update_options', payload: { options: { messageBanner: { isEnabled: cart.item_count > 0, message: message, color: '#f6f2eb', textColor: '#650d32' } } } }, origin);
  }
  function cartSignature(cart) {
    return cart ? JSON.stringify([cart.total_price, cart.items.map(function (item) { return [item.key, item.quantity, item.final_line_price]; })]) : '';
  }
  function queuePrepaid(waitForChange) {
    clearTimeout(bannerTimer);
    var baseline = cartSignature(prepaidCart);
    var remaining = waitForChange ? 12 : 0;
    function readCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); }).then(function (cart) {
        if (remaining-- > 0 && cartSignature(cart) === baseline) { bannerTimer = setTimeout(readCart, 400); return; }
        updatePrepaid(cart);
      }).catch(function () {});
    }
    bannerTimer = setTimeout(readCart, 150);
  }
  window.addEventListener('message', function (event) {
    var frame = document.querySelector('iframe.razorpay-sidecart-frame');
    if (!frame || event.source !== frame.contentWindow || event.origin !== 'https://api.razorpay.com') return;
    var data = event.data;
    if (typeof data === 'string') { try { data = JSON.parse(data); } catch (error) { return; } }
    if (!data || data.source !== 'sidecart') return;
    if (data.eventType === 'checkout_click') window.dispatchEvent(new Event('ek:magic-checkout-click'));
    if (data.eventType === 'frame_loaded') queuePrepaid();
    if (data.eventType === 'async_event' && data.payload && data.payload.name === 'update_cart') queuePrepaid(true);
  });
  var opening = null;
  var wasOpen = false;
  var replaying = false;
  function ready() {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('iframe.razorpay-sidecart-frame')) return resolve();
      var timer = setTimeout(function () { observer.disconnect(); reject(new Error('Magic Cart did not load')); }, 12000);
      var observer = new MutationObserver(function () {
        if (!document.querySelector('iframe.razorpay-sidecart-frame')) return;
        clearTimeout(timer); observer.disconnect(); resolve();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
  function updateCount(cart) {
    updatePrepaid(cart);
    document.querySelectorAll('[data-asc-cartcount]').forEach(function (el) {
      el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    window.dispatchEvent(new CustomEvent('ek:cart-change', { detail: { count: cart.item_count, cart: cart } }));
  }
  function showBagError() {
    var old = document.querySelector('.ek-bag-error');
    if (old) old.remove();
    var copy = {};
    try { copy = JSON.parse(document.getElementById('ek-cro-copy').textContent); } catch (error) {}
    var box = document.createElement('div');
    box.className = 'ek-bag-error'; box.setAttribute('role', 'alert');
    var close = document.createElement('button'); close.type = 'button'; close.setAttribute('aria-label', 'Close'); close.textContent = '×';
    close.addEventListener('click', function () { box.remove(); });
    var text = document.createElement('p'); text.textContent = copy.checkoutError;
    var link = document.createElement('a'); link.href = '/cart?view_bag=1'; link.setAttribute('data-allow-cart-page', ''); link.textContent = 'View bag';
    box.append(close, text, link); document.body.appendChild(box);
  }
  function refresh(openAfter) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .then(function (cart) { updateCount(cart); return (openAfter ? open() : Promise.resolve()).then(function () { return fetch('/?sections=asc-cart-drawer').then(function (r) { return r.json(); }).then(function (sections) {
        var root = document.getElementById('shopify-section-asc-cart-drawer');
        if (root && sections['asc-cart-drawer']) {
          var live = root.querySelector('.asc-cd-checkout-form');
          root.innerHTML = sections['asc-cart-drawer'];
          var fresh = root.querySelector('.asc-cd-checkout-form');
          if (live && fresh) fresh.replaceWith(live);
        }
        return cart;
      }); }); });
  }
  function open() {
    if (opening) return opening;
    opening = ready().then(function () {
      return new Promise(function (resolve, reject) {
        var attempts = 0;
        function attempt() {
          var container = document.querySelector('.razorpay-sidecart-container');
          if (container && getComputedStyle(container).display !== 'none') return resolve();
          if (++attempts > 40) return reject(new Error('Magic Cart not ready'));
          var trigger = document.querySelector('[data-asc-cart-open][data-rzp-cart-icon]');
          if (trigger) { replaying = true; trigger.click(); replaying = false; }
          setTimeout(attempt, 250);
        }
        attempt();
      });
    }).finally(function () { opening = null; });
    return opening;
  }
  window.ekCart = { open: open, refresh: refresh };
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-asc-cart-open]') || replaying) return;
    event.preventDefault(); event.stopImmediatePropagation();
    open().catch(showBagError);
  }, true);
  function syncOverlays() {
    var container = document.querySelector('.razorpay-sidecart-container');
    var active = !!container && getComputedStyle(container).display !== 'none' && getComputedStyle(container).visibility !== 'hidden';
    if (document.body.classList.contains('ek-magic-cart-open') !== active) document.body.classList.toggle('ek-magic-cart-open', active);
    if (!wasOpen && active) { queuePrepaid(); window.dispatchEvent(new Event('ek:magic-cart-visible')); }
    if (wasOpen && !active) refresh(false).catch(function () {});
    wasOpen = active;
  }
  new MutationObserver(syncOverlays).observe(document.body, { childList: true, attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
  syncOverlays();
  window.addEventListener('ek:cart-open', function () { refresh(true).catch(showBagError); });
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-allow-cart-page')) return;
    if (new URL(link.href, location.origin).pathname.replace(/\/$/, '') === '/cart') {
      event.preventDefault();
      open().catch(showBagError);
    }
  });
  try {
    if (sessionStorage.getItem('asc-open-cart')) {
      sessionStorage.removeItem('asc-open-cart');
      window.addEventListener('load', function () { refresh(true).catch(showBagError); }, { once: true });
    }
  } catch (error) {}
})();